import {contentfulQueryKeys} from '../../../constants'
import {blogArticleQuery} from '../queries'
import {useContentfulQueryWithHook} from './use-contentful-query.hook'

export const useBlogArticle = (slug) => {
    const {data, error} = useContentfulQueryWithHook(
        [...contentfulQueryKeys.getBlogArticle, slug],
        blogArticleQuery,
        {slug}
    )

    const filteredData = data?.articleCollection?.items?.[0]

    return {filteredData, error}
}
